import { getFormLink, getTicketingLink } from "../routes";
import { getIsoLocaleFromCountry, getIsoLocalesFromFields } from "./locale";
export const getDonationFormCanonicalTags = ({ frontendUrl, donationForm, fieldsLocales, country, }) => {
    const isoLocales = getIsoLocalesFromFields(fieldsLocales, country);
    const mainIsoLocale = getIsoLocaleFromCountry(country, donationForm.locale);
    const alternateIsoLocales = isoLocales.filter((isoLocale) => isoLocale !== mainIsoLocale);
    const mainUrl = `${frontendUrl}${getFormLink(donationForm, mainIsoLocale)}`;
    return {
        url: mainUrl,
        default: mainUrl,
        alternate: alternateIsoLocales.reduce((acc, isoLocale) => {
            acc[isoLocale] = `${frontendUrl}${getFormLink(donationForm, isoLocale)}`;
            return acc;
        }, {}),
    };
};
export const getTicketingCanonicalTags = ({ frontendUrl, ticketing, fieldsLocales, country, }) => {
    const isoLocales = getIsoLocalesFromFields(fieldsLocales, country);
    const mainIsoLocale = getIsoLocaleFromCountry(country, ticketing.locale);
    const alternateIsoLocales = isoLocales.filter((isoLocale) => isoLocale !== mainIsoLocale);
    const mainUrl = `${frontendUrl}${getTicketingLink(ticketing.path, mainIsoLocale)}`;
    return {
        url: mainUrl,
        default: mainUrl,
        alternate: alternateIsoLocales.reduce((acc, isoLocale) => {
            acc[isoLocale] = `${frontendUrl}${getTicketingLink(ticketing.path, isoLocale)}`;
            return acc;
        }, {}),
    };
};
